import { render, staticRenderFns } from "./Comparator.vue?vue&type=template&id=8db1eeb8&"
import script from "./Comparator.vue?vue&type=script&lang=ts&"
export * from "./Comparator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports